/**
 * useLangSync · v2.7.45+E9 (2026-02-22)
 * ═════════════════════════════════════════════════════════════════════
 * Keeps the root <html lang> + <dir> attributes in sync with the
 * currently-active i18n language. Screen readers + browser hyphenation
 * + search engines all depend on this attribute being correct.
 *
 * Mount once at the root (App.jsx). No props — reads from i18next.
 */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_CODES } from "./index";

// At present none of our supported languages are RTL. The map is
// here so adding ar/he/fa later is a one-line change.
const RTL_LANGS = new Set([]);

export default function useLangSync() {
  const { i18n } = useTranslation();
  useEffect(() => {
    const apply = (lng) => {
      const base = (lng || "en").split("-")[0];
      const code = SUPPORTED_CODES.includes(base) ? base : "en";
      document.documentElement.lang = code;
      document.documentElement.dir = RTL_LANGS.has(code) ? "rtl" : "ltr";
    };
    apply(i18n.resolvedLanguage || i18n.language);
    i18n.on("languageChanged", apply);
    return () => { i18n.off("languageChanged", apply); };
  }, [i18n]);
}
